import React, { FC } from 'react';

type SettingsCardType = {
  onClick: () => void;
  icon: any;
  description: string;
  name: string;
};
const SettingsCard: FC<SettingsCardType> = ({ onClick, icon, name, description }) => {
  return (
    <div
      className='flex juistify-start gap-5 items-center border rounded-lg border-[#efeded] py-3 px-4 cursor-pointer'
      onClick={onClick}>
      {icon}
      <div>
        <p className='text-sm'>{name}</p> <p className='text-[#858585] text-xs'>{description}</p>
      </div>
    </div>
  );
};

export default SettingsCard;
